module.exports = __webpack_public_path__ + "img/althero.2b7fe053.svg";